var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 206.39 294.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#003e4d;}.cls-2{fill:#00acd7;}.cls-3{fill:#fff;}.cls-4{mix-blend-mode:soft-light;}.cls-5{opacity:.84;}.cls-6{isolation:isolate;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.34,290.64s-.08,0-.12,0c-.68,0-1.35-.01-2-.03-14.36-.49-19.77-6.26-25.99-12.89-4.84-5.17-9.85-10.51-19.35-13.52-10.48-3.32-17.53,.81-24.34,4.8-5.27,3.09-10.36,6.07-17.18,6.07-3.79,0-8.13-.92-13.33-3.25-11.41-5.12-18.53-15.82-21.16-31.82-.75-4.57-1.13-9.58-1.16-14.99-1.3-.16-2.59-.32-3.89-.48,0,5.81,.4,11.18,1.21,16.09,2.85,17.37,10.72,29.07,23.4,34.75,5.74,2.58,10.62,3.57,14.9,3.57,7.93,0,13.78-3.43,19.16-6.58,6.64-3.89,12.37-7.25,21.21-4.45,8.54,2.71,12.98,7.45,17.69,12.48,6.27,6.69,12.74,13.6,28.81,14.12,.65,.02,1.32,.03,2,.03,.04,0,.08,0,.13,0,.03-.6,.05-1.24,.05-1.91s-.02-1.35-.05-1.97Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "79.4 197.53 63.77 232.01 98.21 232.01 79.4 197.53"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 81.39,
    cy: 103.31,
    rx: 81.39,
    ry: 103.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103.51,191.41c-44.95,0-81.39-46.25-81.39-103.31,0-33.53,12.58-63.32,32.08-82.19C22.62,20.11,0,58.36,0,103.31c0,57.06,36.44,103.31,81.39,103.31,18.54,0,35.63-7.87,49.31-21.12-8.5,3.82-17.66,5.91-27.19,5.91Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M110.45,80.43c-6.61-2.9-15.75-4.52-25.2-4.87v-3.91c0-4.17-.33-6.91-.98-8.23-.66-1.31-2.06-2.03-4.22-1.98-1.74,.04-3.03,.69-3.9,1.87-.86,1.18-1.29,2.88-1.29,5.08,0,3.68,.88,6.17,2.66,7.59,1.68,1.39,6.96,4.22,15.21,8.95,6.97,4,11.09,6.79,13.18,8.48,2.1,1.72,3.72,3.91,4.96,6.41,1.23,2.51,1.78,5.39,1.79,9.1-.03,5.85-1.42,11.71-5.14,18.19-3.7,6.3-10.09,13.06-19.81,15.6v8.83c-4.32,.72-8.74,.7-13.05-.07,0-3.04,0-6.07,0-9.11-7.53-1.73-13.64-7.02-18.12-13.36-4.48-6.5-6.1-13.32-6.14-20.66v-3.3c6.07,1.99,14.9,3.18,24.26,3.56,0,1.91,0,3.83,0,5.74,0,6.3,.29,10.24,.87,11.82,.58,1.58,1.99,2.48,4.24,2.54,1.92,.05,3.36-.54,4.29-1.64,.94-1.11,1.4-2.73,1.4-4.83,0-5.29-.44-9.06-1.33-11.33-.88-2.26-3.96-4.72-9.13-7.52-8.63-4.76-13.81-7.88-16.38-9.6-2.6-1.76-4.63-4.03-6.22-6.58-1.58-2.56-2.27-5.21-2.27-8.65,.03-4.9,1.4-10.18,5.06-16.16,3.64-5.81,9.91-12.19,19.47-14.64,0-2.49,0-4.99,0-7.48,4.31-.77,8.73-.79,13.05-.07v7.49c8.73,2.23,14.56,7.95,18.04,13.4,3.49,5.6,4.88,10.87,4.91,16.07,0,.74-.06,1.82-.2,3.27Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M130.3,56.32c-1.95,0-3.85-.99-4.93-2.79-9.26-15.45-23.25-23.74-23.39-23.82-2.74-1.6-3.66-5.12-2.06-7.85,1.6-2.74,5.12-3.66,7.85-2.06,.68,.4,16.68,9.89,27.44,27.83,1.63,2.72,.75,6.24-1.97,7.87-.92,.55-1.94,.82-2.95,.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M142.79,85.4c-2.95,0-5.46-2.26-5.71-5.25-.4-4.62-1.43-9.21-3.06-13.64-1.1-2.97,.42-6.27,3.4-7.37,2.97-1.1,6.27,.42,7.37,3.4,1.99,5.39,3.25,10.99,3.73,16.64,.27,3.16-2.07,5.94-5.23,6.21-.17,.01-.33,.02-.5,.02Z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeScreen);
export default __webpack_public_path__ + "static/media/home-screen.7fc0dc49db6a1f43d3013a75591dec50.svg";
export { ForwardRef as ReactComponent };